import { render, staticRenderFns } from "./SupplyPointForm1.vue?vue&type=template&id=64106128&scoped=true"
import script from "./SupplyPointForm1.ts?vue&type=script&lang=ts&external"
export * from "./SupplyPointForm1.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64106128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64106128')) {
      api.createRecord('64106128', component.options)
    } else {
      api.reload('64106128', component.options)
    }
    module.hot.accept("./SupplyPointForm1.vue?vue&type=template&id=64106128&scoped=true", function () {
      api.rerender('64106128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P38/SupplyPointForm1/SupplyPointForm1.vue"
export default component.exports